import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tasksApi } from '../api';
import { TaskLabel } from '@demind-inc/core';

interface UseAddTaskLabelParams {
  taskLabelGroupId: string;
  newLabel: Omit<TaskLabel, 'id'>;
}

export const useAddTaskLabel = () => {
  const queryClient = useQueryClient();

  const addTaskLabelMutation = useMutation({
    mutationFn: async ({ taskLabelGroupId, newLabel }: UseAddTaskLabelParams) => {
      const response = await tasksApi.createTaskLabel(taskLabelGroupId, newLabel);
      const { taskLabelId, label } = response.data as { taskLabelId?: string; label?: TaskLabel };

      if (label) {
        return label as TaskLabel;
      }

      if (!taskLabelId) {
        throw new Error('Label creation did not return an id');
      }

      return { ...newLabel, id: taskLabelId } as TaskLabel;
    },
    onSuccess: (_createdLabel, { taskLabelGroupId }) => {
      const queryKey = ['lifestack.todo.tasks.labels', { taskLabelGroupId }] as const;
      queryClient.invalidateQueries({ queryKey });
      queryClient.invalidateQueries({ queryKey: ['lifestack.todo.tasks.labels'] });
    },
  });

  return {
    ...addTaskLabelMutation,
    addTaskLabel: addTaskLabelMutation.mutateAsync,
  };
};
